export function playSound(soundFile, options = {}) {
  if (!window.soundEnabled || window.globalVolume === 0) {
    return null;
  }

  const {
    volume = window.globalVolume || 0.5,
    loop = false,
    onEnded = null,
    onError = null,
  } = options;

  try {
    const audio = new Audio(`./sound/${soundFile}`);

    audio.volume = volume;
    audio.loop = loop;

    if (onEnded) {
      audio.addEventListener("ended", onEnded);
    }

    if (onError) {
      audio.addEventListener("error", onError);
    }

    audio.play().catch((error) => {
      if (onError) onError(error);
    });

    if (!window.allAudioInstances) {
      window.allAudioInstances = [];
    }
    window.allAudioInstances.push(audio);

    return audio;
  } catch (error) {
    console.log(`Ошибка создания аудио для ${soundFile}:`, error);
    if (onError) onError(error);
    return null;
  }
}

export function playBackgroundMusic() {
  window.playBackgroundMusic = () =>
    playSound("background.mp3", {
      volume: (window.globalVolume || 0.5) * 0.3,
      loop: true,
    });

  return window.playBackgroundMusic();
}

export function playWinMusic() {
  return playSound("volshebstvo.mp3", {
    volume: window.globalVolume || 0.5,
  });
}

export function winSpinSound() {
  return playSound("exxa.mp3", {
    volume: window.globalVolume || 0.5,
  });
}

export function finalSound() {
  return playSound("winAndEcho.mp3", {
    volume: window.globalVolume || 0.5,
  });
}

export function playSlotSound() {
  return playSound("letsgoy.mp3", {
    volume: window.globalVolume || 0.5,
  });
}

export function playSlotSpinSound() {
  return playSound("cartoon-pop-low.mp3", {
    volume: window.globalVolume || 0.7,
  });
}

export function playSpinSound() {
  return playSound("spin.mp3", {
    volume: window.globalVolume || 0.5,
  });
}

export function threeSpinSound() {
  return playSound("crystal_swoosh_77.mp3", {
    volume: window.globalVolume || 0.5,
  });
}

export function playButtonClick() {
  return playSound("click.mp3", {
    volume: window.globalVolume || 0.3,
  });
}

export function playWinSound() {
  return playSound("win.mp3", {
    volume: window.globalVolume || 0.6,
  });
}
